import { useState } from 'react'
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material'
import CurrencyInput from '../../components/form/CurrencyInput/CurrencyInput'
import { isAnyBlank } from '../../utils/string'
import FormaPagoSelector from '../../components/form/FormaPagoSelector/FormaPagoSelector'
import FechaSelector from '../../components/form/FechaSelector/FechaSelector'
import { dateToString } from '../../utils/date'
import css from './ModalNuevoIngresoPago.module.css'

const ModalNuevoIngresoPago = ({ open, pago, onClose, onSubmit }) => {
  const [formaPago, setFormaPago] = useState('')
  const [importe, setImporte] = useState('')
  const [fecha, setFecha] = useState(null)

  const isImporteValido = (pago?.importeRestante || 0) >= +importe
  const isTransferencia = formaPago === 'TRANSFERENCIA'

  const isSubmitDisabled =
    isAnyBlank(formaPago, importe) ||
    !isImporteValido ||
    (isTransferencia && !fecha)

  const handleSubmit = () => {
    const payload = { id: pago.id, formaPago, importe }
    if (isTransferencia) payload.fecha = dateToString(fecha)
    onSubmit(payload)
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='sm'>
      <DialogTitle>Nuevo ingreso</DialogTitle>
      <DialogContent className={css.main}>
        <DialogContentText className={css.intro}>
          Vas a añadir un nuevo ingreso para {pago?.alumno}.
          <br />
          El dinero se asignará directamente al pago de{' '}
          <strong>{pago?.concepto}</strong>.
        </DialogContentText>
        {!isImporteValido && (
          <Alert className={css.alert} severity='error'>
            El importe marcado es superior al importe que queda pendiente de
            pago.
          </Alert>
        )}
        {isTransferencia && (
          <Alert className={css.alert} severity='info'>
            Es necesario indicar la fecha en la que se realizó la transferencia.
          </Alert>
        )}
        <FormaPagoSelector
          className={css.input}
          name='formaPago'
          label='Forma de pago'
          value={formaPago}
          onChange={e => setFormaPago(e.target.value)}
        />
        {isTransferencia && (
          <>
            <FechaSelector
              className={css.input}
              name='Fecha'
              label='Fecha'
              value={fecha}
              onChange={value => setFecha(value)}
            />
          </>
        )}
        <CurrencyInput
          className={css.input}
          name='importe'
          label='Importe'
          value={importe}
          onChange={value => setImporte(value)}
        />
      </DialogContent>
      <DialogActions>
        <Button color='error' onClick={onClose}>
          Cancelar
        </Button>
        <Button
          color='primary'
          disabled={isSubmitDisabled}
          onClick={handleSubmit}
        >
          Añadir ingreso
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalNuevoIngresoPago
